import axios from "axios";

const API = `${window.location.origin}/api/budget`;
const POLL_MS = 2500;
const MAX_WAIT_MS = 8 * 60 * 1000;

/**
 * Start an AI takeoff parse as a background job and poll until it finishes.
 * Avoids long-lived HTTP requests that get killed by Cloudflare/ingress
 * timeouts in production (parsing takes 40-120s).
 * Resolves with the parsed budget payload; throws Error with a user-facing message.
 */
export async function runTakeoffJob(formData) {
  const { data: start } = await axios.post(`${API}/ai-takeoff`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000,
  });
  const jobId = start.job_id;
  const deadline = Date.now() + MAX_WAIT_MS;
  let lastError = null;
  while (Date.now() < deadline) {
    await new Promise((r) => setTimeout(r, POLL_MS));
    try {
      const { data: job } = await axios.get(`${API}/ai-takeoff/jobs/${jobId}`, { timeout: 20000 });
      if (job.status === "done") return job.result;
      if (job.status === "error") throw new Error(job.error || "AI takeoff failed");
      lastError = null;
    } catch (e) {
      // Job errors are terminal; transient network/timeout errors are not —
      // the job keeps running server-side, so keep polling until the deadline.
      if (e.message && !e.response && !e.request) throw e;
      if (e.response?.status === 404 || e.response?.status === 403) throw new Error("AI takeoff job not found.");
      lastError = e;
    }
  }
  throw new Error(lastError ? "Lost connection while waiting for the AI takeoff. Please try again." : "AI takeoff timed out. Please try again.");
}
